import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { StatusIcon } from '../../../bombiix-icon';
import { styleInsidePopover } from '../../../Components/helper';
import { FloatyButton } from '../../../Components/Floaty';

function BtnStatus({ onBtnClick, options, val, selectedIds }) {
  const { t } = useTranslation('common');

  return (
    <OverlayTrigger
      placement="top"
      trigger="click"
      rootClose
      overlay={
        <Popover className="custom-popover">
          <Popover.Content>
            <Select
              options={options}
              menuPlacement="top"
              isClearable
              value={val}
              classNamePrefix="common-select"
              getOptionLabel={(option) => `${option.name}`}
              getOptionValue={(option) => `${option._id}`}
              onChange={onBtnClick}
              styles={styleInsidePopover}
              placeholder={t('FILTER.PRODUCT_STATUS')}
            />
          </Popover.Content>
        </Popover>
      }
    >
      <FloatyButton
        icon={StatusIcon}
        label={t('FILTER.CHANGE_STATUS')}
        disabled={selectedIds?.length === 0}
        className={val ? 'active' : undefined}
        showTooltip={false}
      />
    </OverlayTrigger>
  );
}

export default BtnStatus;
